export enum FdfFormMode {
    CREATE = 'CREATE',
    EDIT = 'EDIT',
    DUPLICATE = 'DUPLICATE',
}
